var __WEBPACK_NAMESPACE_OBJECT__ = require("@fortawesome/fontawesome-svg-core");